(() => {
  'use strict';

  const SERUM_VARIANT_ID = 48114722504922;
  const SERUM_BUNDLE_VARIANT_ID = 48114722537690;
  const GIFT_VARIANT_ID = 48069337743578;
  const DISCOUNT_CODE = 'SUMEO';
  const GIFT_PROPERTY = '_sumeo_welcome_gift';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let syncing = false;
  let scheduledTimer;

  const cartRequest = async (path, options = {}) => {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });
    if (!response.ok) throw new Error('SUMEO cart request failed: ' + response.status);
    return response.json();
  };

  const isAutoGift = (item) =>
    Number(item.variant_id) === GIFT_VARIANT_ID &&
    item.properties && item.properties[GIFT_PROPERTY] === 'true';



  async function syncGift() {
    if (syncing) return;
    syncing = true;
    try {
      let cart = await cartRequest('cart.js');
      let changed = false;
      const bundles = cart.items.filter(
        (item) => Number(item.variant_id) === SERUM_BUNDLE_VARIANT_ID
      );
      if (bundles.length) {
        const singleLine = cart.items.find(
          (item) => Number(item.variant_id) === SERUM_VARIANT_ID &&
            !item.selling_plan_allocation &&
            Object.keys(item.properties || {}).length === 0
        );
        const updates = {};
        for (const bundle of bundles) updates[bundle.key] = 0;
        updates[singleLine ? singleLine.key : SERUM_VARIANT_ID] =
          (singleLine ? singleLine.quantity : 0) +
          bundles.reduce((total, item) => total + item.quantity * 2, 0);
        cart = await cartRequest('cart/update.js', {
          method: 'POST',
          body: JSON.stringify({ updates }),
        });
        changed = true;
      }
      const serumQuantity = cart.items
        .filter((item) => Number(item.variant_id) === SERUM_VARIANT_ID)
        .reduce((total, item) => total + item.quantity, 0);
      const autoGift = cart.items.find(isAutoGift);
      const anyMaker = cart.items.find((item) => Number(item.variant_id) === GIFT_VARIANT_ID);
      const discountApplied = (cart.discount_codes || []).some(
        (discount) => discount.code && discount.code.toUpperCase() === DISCOUNT_CODE
      );
      if (serumQuantity >= 2) {
        if (!anyMaker) {
          await cartRequest('cart/add.js', {
            method: 'POST',
            body: JSON.stringify({
              items: [{
                id: GIFT_VARIANT_ID,
                quantity: 1,
                properties: { [GIFT_PROPERTY]: 'true' },
              }],
            }),
          });
          changed = true;
        } else if (autoGift && autoGift.quantity !== 1) {
          await cartRequest('cart/change.js', {
            method: 'POST',
            body: JSON.stringify({ id: autoGift.key, quantity: 1 }),
          });
          changed = true;
        }

        if (!discountApplied) {
          await cartRequest('cart/update.js', {
            method: 'POST',
            body: JSON.stringify({ discount: [...new Set([...(cart.discount_codes || []).map((discount) => discount.code).filter(Boolean), DISCOUNT_CODE])].join(',') }),
          });
          changed = true;
        }
      } else if (autoGift) {
        await cartRequest('cart/change.js', {
          method: 'POST',
          body: JSON.stringify({ id: autoGift.key, quantity: 0 }),
        });
        changed = true;
      }

      if (changed) {
        if (bundles.length) window.location.assign(root + 'cart');
        else window.location.reload();
      }
    } catch (error) {
      console.warn('[SUMEO Auto Gift]', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync(delay = 350) {
    clearTimeout(scheduledTimer);
    scheduledTimer = setTimeout(syncGift, delay);
  }

  document.addEventListener('DOMContentLoaded', () => scheduleSync(100));
  document.addEventListener('change', (event) => {
    if (event.target.closest('cart-items, cart-drawer, [data-cart], #CartDrawer, #CartDrawerForm')) scheduleSync();
  });
  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) scheduleSync(900);
  });

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
    if (url && /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url) && !syncing && response.ok) await syncGift();
    return response;
  };
})();
